import React from "react"
import { motion } from "framer-motion"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { springVariants, springViewport } from '../utils/framerVariants'

const Faq = ({ data }) => {
  return (
    <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl px-0 md:px-24 xl:px-24 mb-16 md:mb-24 lg:mb-32 xl:mb-48">
      {data.Text &&
        <motion.div
          variants={springVariants}
          initial="invisible"
          whileInView="visible"
          viewport={springViewport}
          className="richtext max-w-6xl mx-auto px-4 lg:px-0 text-text tracking-text leading-text text-center mb-12 md:mb-24"
          dangerouslySetInnerHTML={{
            __html: data.Text,
          }}
        />
      }
      <motion.div
        variants={springVariants}
        initial="invisible"
        whileInView="visible"
        viewport={springViewport}
        className="help__containers chapter mb-0">
        {data.FAQ.map((entry, i) => (
          <Accordion>
            <AccordionSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <h2 className="text-headline-md tracking-headline-md leading-headline-md font-semibold">{entry.Question}</h2>
            </AccordionSummary>
            <AccordionDetails>
              <div className="richtext" dangerouslySetInnerHTML={{
                __html: entry.Answer,
              }} />
            </AccordionDetails>
          </Accordion>
        ))}
      </motion.div>

    </article>
  )
}

export default Faq
